export default __webpack_public_path__ + "static/media/icon-arrow-order.fb730da2.svg";